// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2IER9","title":"AfterBackImages_title__RGWez","images":"AfterBackImages_images__1Z-lE"};